import { CCardFooter } from "@coreui/react";
import { Box, Button, Card, CardContent, CardHeader, Divider, IconButton, MenuItem, Select, SelectChangeEvent, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import {AttachFile, Delete} from '@mui/icons-material'
import { T_Inquery } from "../../common/model/InqueryModel";
import apis from "../../common/apis";
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import { T_Hand } from "../../common/model/handModel";
export default function HandInsert(){
    const nav = useNavigate();
    const [cstatus ,setCstatus] = useState('0');
    const [data,setData] = useState<T_Hand>({});
    const {alert,setAlert} = useAlert();

    const handleChange = (event: SelectChangeEvent) => {
      setCstatus(event.target.value);
      };
      const [selectedFiles, setSelectedFiles] = useState<File[]>([])

      const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement>,
      ) => {
        if (!event.target.files) return
        setSelectedFiles(Array.from(event.target.files))
      }    

      const handleRemoveFile = (index: number) => {
        setSelectedFiles(prev =>
          prev.filter((_, i) => i !== index)
        )
      }

      const saveData = async()=>{

        if(data.title === "" || data.title === undefined){
            setAlert({...alert,visible:true,title:"확인",msg:"제목을 입력하여 주십시요"})   
            return;
        }
         
        setAlert({...alert,title:"확인",msg:"정말로 등록 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                    const result = await apis.hand.handCreate({...data,filelist:selectedFiles})   
                    console.log("result:",result);
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"등록이 완료되었습니다."})
                        nav("handy")
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"등록중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})


      }

    return(
    <>
    <Card >
        <CardHeader title="핸드로드 사용법 등록" sx={{pb:0,mb:0}}/>
        <CardContent>
            <Divider />
        <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2
          }} > 
            <TableHead />
            <TableBody>
            <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          제목
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField  size="small" fullWidth value={data.title || ''} onChange={(event)=>{setData({...data,title:event.target.value})}} />
                        </TableCell>      

        </TableRow>        

        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          파일첨부
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                        <Button
                        variant="contained"
                        component="label"
                        startIcon={<AttachFile />}
                        >
                        파일 선택
                        <input
                            type="file"
                            hidden
                            multiple                        // 여러 파일 선택허용
                             accept="image/*"        // ← 여기 추가
                            onChange={handleFileChange}
                        />
                        </Button>

                        {/* 선택된 파일명 리스트 */}
                        {selectedFiles.length > 0 && (
                        <Box mt={1}>
                            {selectedFiles.map((file, idx) => (
                               <Box
                               key={idx}
                               sx={{
                                 display: 'flex',
                                 alignItems: 'center',
                                 mt: 0.5,
                               }}
                             >    
                            <Typography
                                variant="body2"
                                key={idx}
                            >
                                {file.name}
                            </Typography>
                            <IconButton
                            size="small"
                            onClick={() => handleRemoveFile(idx)}
                            >
                            <Delete fontSize="small" />
                            </IconButton>
                          </Box>
                            ))}
                        </Box>
                        )}                            
                        </TableCell>      

        </TableRow>        

        </TableBody>

        </Table>

        </CardContent>
        <CCardFooter style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
        <Button variant="contained" onClick={()=>{
        saveData();
    }}>저장</Button>
        <Button variant="outlined" onClick={()=>{
        nav(-1);
    }}>취소</Button>

        </CCardFooter>
    </Card>

    </>)
}